// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Sierra Leone */
const SL = /^(?:(?:25|3[0-5]|66|7\d|8[08]|9[09])\d{6})$/;

export default SL;
